import { render } from "./sponsors.vue?vue&type=template&id=6520d5e6&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=6520d5e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6520d5e6"

export default script